<template>
<v-card class='ma-2 elevation-6' >
  <v-card-title class='overline' >
    <v-btn class='ma-0' small icon ><v-icon small class='mr-2'>send</v-icon></v-btn>
    {{title || value.full_name}}
    <v-spacer></v-spacer>
    <form v-if='value.phone_number && context && sender && templateSlug'
      action='https://unibox.appointmentguru.co/whatsapp/'
      method='POST'
      target='_blank' >
      <v-btn
        type='submit'
        small outline round class='ma-0' color='success' style='float:right' >WhatsApp
        <v-icon small>open_in_new</v-icon>
      </v-btn>
      <input type='hidden' name='to' v-model='value.phone_number' />
      <input type='hidden' name='template' :value='templateSlug' />
      <input type='hidden' name='context' :value='parsedContext' />
    </form>
  </v-card-title>
  <v-divider></v-divider>
  <v-layout row wrap>
    <v-flex xs6 >
      <v-checkbox
        v-model='byEmail'
        class='ml-3 py-2 pa-0 ma-0' label='email'
        :disabled='!(value.email) || !isRealEmail(value.email)'
        :hint='emailHint(value)'
        persistent-hint >
      </v-checkbox>
    </v-flex>
    <v-flex xs6 >
      <v-checkbox
        class='ml-3 py-2 pa-0 ma-0'
        v-model='bySMS'
        label='sms'
        :disabled='!value.phone_number'
        :hint='value.phone_number || "No phone number available"' persistent-hint >
      </v-checkbox>
    </v-flex>
    <v-flex xs12 >

    </v-flex>
  </v-layout>
</v-card>
</template>
<script>
export default {
  name: 'RecipientCard',
  props: {
    title: { type: String },
    templateSlug: { type: String },
    value: { type: Object, required: true },
    sender: { type: Object, required: false },
    context: { type: Object, required: false }
  },
  data () {
    return {
      bySMS: false,
      byEmail: false,
      recipient: {}
    }
  },
  computed: {
    parsedContext () {
      if (this.context) {
        this.context.recipient = this.recipient
        this.context.sender = this.sender
        return JSON.stringify(this.context)
      }
      return '{}'
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) { this.recipient = this.value }
      }
    },
    bySMS () {
      this.$emit('sendTo', 'bySMS', this.bySMS, this.recipient)
    },
    byEmail () {
      this.$emit('sendTo', 'byEmail', this.byEmail, this.recipient)
    }
  },
  methods: {
    emailHint (client) {
      if (client.email && this.isRealEmail(client.email)) {
        return client.email
      }
      return 'No email available'
    }
  }
}
</script>



// WEBPACK FOOTER //
// RecipientCard.vue?57a64f23